export default __webpack_public_path__ + "static/media/breadcrumb-bg.b2911048.jpg";